import { MouseEvent, ReactNode } from 'react';

import { IUserOrderFragment } from 'generated/rbi-graphql';
import { ServiceMode } from 'state/order';

export interface IBottomServiceModeProps {}

export interface IBottomServiceModeDetail {
  heading: string;
  details: string;
  icon: ReactNode;
  buttonContentText: string;
  buttonContentIcon: ReactNode;
  onButtonClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  onBottomServiceClick?: () => void;
  buttonDisabled?: boolean;
  variant?: BottomServiceVariants;
  CancellationModal: React.FC;
}

export interface IOrderInProgress {
  recentOrder: IUserOrderFragment | null | undefined;
  curbsidePickupOrderId: string;
  serviceMode: ServiceMode;
  isDeliveryOrderCompleted: boolean;
}
export interface IOrderInProgressResult {
  headingId: string;
  detailsId: string;
  icon: ReactNode;
  buttonContentTextId: string;
  buttonContentIcon: ReactNode;
  variant: BottomServiceVariants;
}

export interface IBottomServiceModeViewProps
  extends Omit<IBottomServiceModeDetail, 'CancellationModal'> {
  isLoading?: boolean;
  className?: string;
}

export enum BottomServiceVariants {
  DEFAULT,
  IN_PROGRESS,
  NO_STORE
}
